export default "__VITE_ASSET__CJNiag9v__"